import { Component, OnInit, effect } from '@angular/core';
import { TranslateService } from '@ngx-translate/core';

import { EventTypes } from 'src/app/core/constants/event-types';
import { DynamicTabService } from 'src/app/core/services/dynamic-tab.service';
import { BasePageComponent } from 'src/app/pages/shared/base/components/base-page.component';
import { BaseIndexModule } from 'src/app/pages/shared/base/modules/base-index.module';
import { CustomResultOfUserDto, UserDto } from '../../../../core/api/models';
import { UserState } from '../../../../core/api/models/user-state';
import { UsersService } from '../../../../core/api/services';
import { FormPageConfig } from '../../../../core/models/form-page-config.model';
import { TranslationService } from '../../../../i18n/translation.service';
import { OrganizationsAuthenticationFormComponent } from '../../organizations/organizations-authentication-form/organizations-authentication-form.component';
import { UserAuthenticationFormComponent } from '../user-authentication-form/user-authentication-form.component';
import { UserFormModule } from '../user-form/user-form.module';

@Component({
  selector: 'app-user-personal-info',
  templateUrl: './user-personal-info.component.html',
  styleUrls: ['./user-personal-info.component.scss'],
  imports: [
    BaseIndexModule,
    OrganizationsAuthenticationFormComponent,
    UserFormModule,
    UserAuthenticationFormComponent,
  ],
})
export class UserPersonalInfoComponent
  extends BasePageComponent
  implements OnInit
{
  //#region properties

  pageVocabs = 'pages.users.personalInfo.';

  model: UserDto;
  formPageConfig: FormPageConfig<UserDto> = {};

  isVisibleForm: boolean = false;

  isNotUserOrganization: boolean = false;
  isNotActiveUserOrganization: boolean = false;
  isVisibleUploadForm: boolean = false;
  isNotAuthenticated: boolean = false;
  isExpired: boolean = false;
  notAuthenticatedUser: boolean = false;
  isExpireOrganization: boolean = false;
  fullName: string = '';

  //#endregion

  constructor(
    protected currentService: UsersService,
    protected translationService: TranslationService,
    protected translate: TranslateService,
    private dynamicTabService: DynamicTabService
  ) {
    super();
    effect(() => {
      if (this.userSession.userState()) {
      }
      this.getUserState();
    });
  }

  ngOnInit() {
    this.getUserState();
  }

  getUserState() {
    try {
      this.unSubs();
      this.currentUserInfo.userId = this.userSession.userState().userId;

      switch (this.userSession.userState().state) {
        case UserState.Normal:
          this.getCurrentUserInfoApi();
          this.isVisibleForm = false;
          break;
        case UserState.NotRegister:
          this.onCreate();
          break;
        case UserState.NotOrganization:
          this.isNotUserOrganization = true;
          break;
        case UserState.NotActive:
          this.isNotActiveUserOrganization = true;
          break;
        case UserState.NotAuthenticated:
          this.isNotAuthenticated = true;
          break;
        case UserState.ExpireUser:
          this.isExpired = true;
          break;
        case UserState.ExpireOrganization:
          this.isExpireOrganization = true;
          break;
        case UserState.NotAuthenticatedUser:
          {
            // if (res.isRealPerson)
            this.notAuthenticatedUser = true;
            // else {
            //  this.notAuthenticatedUser = true;
            // this.isNotAuthenticated = true;

            //}
          }

          break;
      }
    } catch (error) {
      this.loggerService.logError(
        this.tagName,
        error,
        EventTypes.systemManagement
      );
    }
  }

  //#region api

  getCurrentUserInfoApi(showForm?: boolean): void {
    this.unSubs();

    this.pageConfig.loading = true;

    this.currentService
      .usersUpdateCurrentUserInfoGet()
      .pipe(this.basePipeOperators())
      .subscribe((res: CustomResultOfUserDto) => {
        try {
          this.model = res.data;
          this.fullName = this.model?.firstName + ' ' + this.model?.lastName;
          if (showForm) {
            this.formPageConfig.editData = res.data;
            this.formPageConfig.isEditMode = true;
            this.formPageConfig.editId = res.data.id;
            this.formPageConfig.vocabs = 'pages.users.form.';
            this.pageConfig.isVisibleForm = true;
          }
        } catch (error) {
          this.loggerService.logError(
            this.tagName,
            error,
            EventTypes.systemManagement
          );
        }
      });
  }

  //#endregion

  uploadDocuments() {
    try {
      this.isVisibleUploadForm = true;
      this.formPageConfig.vocabs =
        'pages.users.userInfo.userAuthentication.form.';
    } catch (error) {
      this.loggerService.logError(
        this.tagName,
        error,
        EventTypes.systemManagement
      );
    }
  }

  onCreate() {
    try {
      this.formPageConfig.title = this.translate.instant(
        'pages.systemManagement.users.userPersonalInfo.userPersonalInfoForm.submitPersonalInfo'
      );
      this.formPageConfig.isEditMode = false;
      this.isVisibleForm = true;
    } catch (error) {
      this.loggerService.logError(
        this.tagName,
        error,
        EventTypes.systemManagement
      );
    }
  }

  //for all forms
  getFormResponse(isSuccess) {
    try {
      if (!this.isNotAuthenticated) if (isSuccess) this.getCurrentUserInfoApi();

      this.isVisibleForm = false;
      this.isVisibleUploadForm = false;
      this.pageConfig.isVisibleForm = false;
    } catch (error) {
      this.loggerService.logError(
        this.tagName,
        error,
        EventTypes.systemManagement
      );
    }
  }

  onBuyPackage() {
    this.dynamicTabService.setNewTab('');
    this.dynamicTabService.setNewTab('buyPlanPackage');
    this.dynamicTabService.setActiveTab('buyPlanPackage');
  }
}
